// Preloader Manager - Hides when API data is loaded
// Tracks center panel initialization and stock data loading

(function() {
    'use strict';
    
    const loadingState = {
        centerPanelLoaded: false,
        stockDataLoaded: false,
        isHidden: false
    };
    
    function hidePreloaderDirectly() {
        const el = document.getElementById('preloader');
        if (el) {
            loadingState.isHidden = true;
            el.style.display = 'none';
            el.style.opacity = '0';
            el.style.visibility = 'hidden';
            el.style.pointerEvents = 'none';
        }
    }
    
    function showPreloaderDirectly() {
        const el = document.getElementById('preloader');
        if (el) {
            loadingState.isHidden = false;
            el.classList.remove('hidden');
            el.style.display = 'flex';
            el.style.opacity = '1';
            el.style.visibility = 'visible';
            el.style.pointerEvents = 'auto';
        }
    }
    
    function checkIfReady() {
        if (loadingState.isHidden) return;
        
        if (loadingState.centerPanelLoaded && loadingState.stockDataLoaded) {
            setTimeout(hidePreloaderDirectly, 300);
        }
    }
    
    function updateTheme() {
        const gif = document.getElementById('preloader-gif');
        if (gif && document.body) {
            const isLight = document.body.classList.contains('light') || document.body.classList.contains('cb-light');
            gif.src = isLight 
                ? './desktop_assets/LoaderLightVerticalv2.gif'
                : './desktop_assets/LoaderLightVerticalv2.gif';
        }
    }
    
    function init() {
        const preloader = document.getElementById('preloader');
        if (!preloader) return;
        
        updateTheme();
        
        if (document.body) {
            new MutationObserver(updateTheme).observe(document.body, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
        
        document.addEventListener('center-panel-initialized', function() {
            loadingState.centerPanelLoaded = true;
            checkIfReady();
        }, { once: false });
        
        document.addEventListener('stock-data-loaded', function() {
            loadingState.stockDataLoaded = true;
            checkIfReady();
        }, { once: false });
        
        const scene = document.querySelector('a-scene');
        if (scene) {
            scene.addEventListener('center-panel-initialized', function() {
                loadingState.centerPanelLoaded = true;
                checkIfReady();
            }, { once: false });
            
            scene.addEventListener('stock-data-loaded', function() {
                loadingState.stockDataLoaded = true;
                checkIfReady();
            }, { once: false });
        }
        
        setTimeout(function() {
            if (!loadingState.isHidden) {
                hidePreloaderDirectly();
            }
        }, 15000);
        
        let pollCount = 0;
        const pollInterval = setInterval(function() {
            pollCount++;
            
            if (!loadingState.centerPanelLoaded) {
                const centerContent = document.getElementById('large-center-panel-content');
                if (centerContent && centerContent.children.length > 0) {
                    const hasContent = Array.from(centerContent.children).some(child => {
                        return child.tagName !== 'SCRIPT' && 
                               (child.children.length > 0 || child.textContent.trim().length > 0);
                    });
                    if (hasContent) {
                        loadingState.centerPanelLoaded = true;
                    }
                }
            }
            
            if (!loadingState.stockDataLoaded) {
                const stockCube = document.querySelector('[stock-cube-visualizer]');
                if (stockCube && stockCube.components && stockCube.components['stock-cube-visualizer']) {
                    const visualizer = stockCube.components['stock-cube-visualizer'];
                    if (visualizer.isInitialized) {
                        loadingState.stockDataLoaded = true;
                    }
                }
            }
            
            checkIfReady();
            
            if (pollCount >= 200 || loadingState.isHidden) {
                clearInterval(pollInterval);
            }
        }, 100);
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(init, 100);
        });
    } else {
        setTimeout(init, 100);
    }
    
    window.PreloaderManager = {
        hide: hidePreloaderDirectly,
        show: showPreloaderDirectly,
        getState: function() {
            return { ...loadingState };
        }
    };
})();
